import ClearIcon from '@mui/icons-material/Clear';
import CancelIcon from '@mui/icons-material/Cancel';
import CancelIconOutlined from '@mui/icons-material/CancelOutlined';

export function getClearIconOption(variant) {
  const options = {
    clear: {
      icon: ClearIcon
    },
    filled: {
      icon: CancelIcon
    },
    default: {
      icon: CancelIconOutlined
    }
  };

  return options[variant] || options.default;
}
